import styled from 'styled-components';
import type { Badge } from '../../../../../types';
import { IconsItem } from './IconsItem';

export function Icons({ icons }: { icons: Badge[] }) {
  return (
    <IconsComponent>
      {icons &&
        icons.map((item, id) => <StyledIconsItem key={id} data={item} />)}
    </IconsComponent>
  );
}

export const IconsComponent = styled.div`
  display: flex;
  flex-direction: row;
`;
export const StyledIconsItem = styled(IconsItem)`
  padding: 0 4px;
`;
